/* src/app/modules/shared/demo/demo.component.scss */
.blue-bullets li::marker {
  color: var(--bs-primary);
}
/*# sourceMappingURL=demo.component-LM5AX22L.css.map */
